import API_URL from "@/globals/api";
import authHeader from "./auth-header";
import axiosInstance from "./api";

class CartService {
  checkout(data) {
    return axiosInstance
      .post(`${API_URL}/orders/checkout`, data, {
        headers: {
          "Content-Type": "application/json",
          ...authHeader()
        },
      })
  }

  /**
   * The cart saved against the account, so it survives a cleared browser and
   * follows the customer to another machine.
   *
   * Returns `{ items, updated_at }`. `updated_at` is an ISO-with-Z string and
   * is what decides which side wins when both have a cart — see
   * store/cart-sync.js.
   */
  getSavedCart() {
    return axiosInstance.get(`${API_URL}/cart`, {
      headers: { "Content-Type": "application/json", ...authHeader() },
    });
  }

  /** Replaces the saved cart. A PUT: the whole array, never a delta. */
  saveCart(items) {
    return axiosInstance.put(
      `${API_URL}/cart`,
      { items },
      { headers: { "Content-Type": "application/json", ...authHeader() } }
    );
  }

  /** Empties the saved cart. Called after a successful checkout. */
  clearSavedCart() {
    return axiosInstance.delete(`${API_URL}/cart`, {
      headers: { "Content-Type": "application/json", ...authHeader() },
    });
  }
}

export default new CartService();
